import React, { useEffect, useState } from "react";
import authApiService from "../../services/authServices";
import { sortCountriesForDropdown } from "../../utils/sortCountriesForDropdown";

const AddressDetails = ({ formData, handleInputChange }) => {
  const [countries, setCountries] = useState([]);
  const [statesForCountry, setStatesForCountry] = useState([]);
  const [isCustomState, setIsCustomState] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await authApiService.get("getCountry");
        if (response && Array.isArray(response.data)) {
          setCountries(sortCountriesForDropdown(response.data));
        } else {
          setCountries([]);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        setCountries([]);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      if (!formData.country) {
        setStatesForCountry([]);
        return;
      }

      try {
        const response = await authApiService.get("getStatesByCountry", {
          countryCode: formData.country,
        });

        if (
          response &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          setStatesForCountry(response.data);
          setIsCustomState(false);
        } else {
          setStatesForCountry([]);
        }
      } catch (error) {
        console.error("Error fetching states by country:", error);
        setStatesForCountry([]);
      }
    };

    fetchStates();
  }, [formData.country]);

  const handleProvinceChange = (e) => {
    const { value } = e.target;

    if (value === "__CUSTOM__") {
      setIsCustomState(true);
      handleInputChange({
        target: {
          name: "province",
          value: "",
        },
      });
    } else {
      setIsCustomState(false);
      handleInputChange(e);
    }
  };

  return (
    <div className="col-sm-12 col-lg-3">
      <fieldset>
        <legend>Address Details</legend>
        <div className="floating-label-wrap">
          <label htmlFor="address" className="floating-label">
            Street<span className="mandatory">*</span>
          </label>
          <input
            id="address"
            name="address"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.address}
            onChange={handleInputChange}
            maxLength={30}
          />
        </div>
        <div className="floating-label-wrap">
          <label htmlFor="city" className="floating-label">
            City (Address)<span className="mandatory">*</span>
          </label>
          <input
            id="city"
            name="city"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.city}
            onChange={handleInputChange}
            maxLength={30}
          />
        </div>
        <div className="styled-input">
          <label htmlFor="country">
            Country <span className="mandatory">*</span>
          </label>
          <select
            name="country"
            id="country"
            className="select"
            value={formData.country}
            onChange={handleInputChange}
          >
            <option value="" disabled>
              Please Select
            </option>
            {countries.map((country) => (
              <option key={country.id} value={country.countryCode}>
                {country.countryName}
              </option>
            ))}
          </select>
        </div>
        <div className="styled-input">
          <label htmlFor="province">
            State<span className="mandatory">*</span>
          </label>
          {statesForCountry.length > 0 ? (
            <>
              <select
                name="province"
                id="province"
                className="select"
                value={formData.province}
                onChange={handleProvinceChange}
              >
                <option value="" disabled>
                  Please Select
                </option>
                {statesForCountry.map((state) => (
                  <option key={state.id} value={state.name}>
                    {state.name}
                  </option>
                ))}
                <option value="__CUSTOM__">Other / Add new state</option>
              </select>
              {isCustomState && (
                <div
                  className="floating-label-wrap"
                  style={{ marginTop: "8px" }}
                >
                  <label htmlFor="customProvince" className="floating-label">
                    Enter State / Province
                  </label>
                  <input
                    id="customProvince"
                    name="province"
                    className="longBox floating-label-field floating-label-field--s3"
                    type="text"
                    value={formData.province}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="floating-label-wrap">
              <label htmlFor="provinceInput" className="floating-label">
                {formData.country
                  ? "Enter State / Province"
                  : "Select country first"}
              </label>
              <input
                id="provinceInput"
                name="province"
                className="longBox floating-label-field floating-label-field--s3"
                type="text"
                value={formData.province}
                onChange={handleInputChange}
                maxLength={50}
              />
            </div>
          )}
        </div>
        <div className="floating-label-wrap">
          <label htmlFor="postal_code" className="floating-label">
            Zip Code<span className="mandatory">*</span>
          </label>
          <input
            id="postal_code"
            name="postal_code"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.postal_code}
            onChange={handleInputChange}
            maxLength={10}
          />
        </div>

        <div className="styled-input pt-2">
          <label htmlFor="date_joined">Date</label>
          <input
            id="todayDate"
            name="date_joined"
            type="text"
            disabled
            value={
              formData.date_joined ? formData.date_joined.split("T")[0] : ""
            }
            onChange={handleInputChange}
          />
        </div>
      </fieldset>
      <fieldset className="equip mt-4">
        <legend htmlFor="equipment">Equipment</legend>
        <div className="floating-label-wrap">
          <label htmlFor="racquet" className="floating-label">
            Racquet
          </label>
          <input
            id="racket"
            name="racket"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.racket}
            onChange={handleInputChange}
            maxLength={30}
          />
        </div>
        <div className="floating-label-wrap">
          <label htmlFor="tennisstring" className="floating-label">
            String
          </label>
          <input
            id="tennisstring"
            name="tennisstring"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.tennisstring}
            onChange={handleInputChange}
            maxLength={30}
          />
        </div>
        <div className="floating-label-wrap">
          <label htmlFor="shoes" className="floating-label">
            Shoes
          </label>
          <input
            id="shoes"
            name="shoes"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.shoes}
            onChange={handleInputChange}
            maxLength={30}
          />
        </div>
        <div className="floating-label-wrap">
          <label htmlFor="favoritePlayer" className="floating-label">
            Favorite Player
          </label>
          <input
            id="favoritePlayer"
            name="favoritePlayer"
            className="longBox floating-label-field floating-label-field--s3"
            type="text"
            value={formData.favoritePlayer}
            onChange={handleInputChange}
            maxLength={30}
          />
        </div>
      </fieldset>
    </div>
  );
};

export default AddressDetails;
